export default __webpack_public_path__ + "static/media/shiba inu.bcd34edd.svg";